<form [formGroup]="formName">
    <p-calendar [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [showIcon]="true"  view="year" dateFormat="yy" [minDate]="minDate" [maxDate]="maxDate"  [placeholder]="placeholder" [readonlyInput]="true"></p-calendar>
</form>